// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__MbqEn","icon":"styles_icon__zaCja","profile":"styles_profile__8K3Kd","sections":"styles_sections__eX7P_"};